import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f1e45a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-textfield-with-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_BFormInput = _resolveComponent("BFormInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.innerIconType === 'email')
      ? (_openBlock(), _createBlock(_component_FeatherIcon, {
          key: 0,
          icon: "mail",
          class: "app-textfield-with-icon__inner-icon app-textfield-with-icon__inner-icon--left"
        }))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.innerIconType === 'password')
      ? (_openBlock(), _createBlock(_component_FeatherIcon, {
          key: 1,
          icon: "lock",
          class: "app-textfield-with-icon__inner-icon app-textfield-with-icon__inner-icon--left"
        }))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.innerIconType === 'phoneNumber')
      ? (_openBlock(), _createBlock(_component_FeatherIcon, {
          key: 2,
          icon: "phone",
          class: "app-textfield-with-icon__inner-icon app-textfield-with-icon__inner-icon--left"
        }))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createVNode(_component_BFormInput, {
      value: _ctx.value,
      type: _ctx.inputType,
      state: _ctx.state,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      inputmode: _ctx.inputmode,
      class: _normalizeClass(["app-textfield-with-icon__input", {
        'app-textfield-with-icon__input--with-icon': !!_ctx.innerIconType,
        'app-textfield-with-icon__input--with-password-icon':
          _ctx.innerIconType === 'password'
      }]),
      onInput: _ctx.onInput,
      onBlur: _ctx.onBlur
    }, null, 8, ["value", "type", "state", "placeholder", "disabled", "inputmode", "class", "onInput", "onBlur"]),
    _createTextVNode(),
    (_ctx.showPasswordToggle && !_ctx.isPasswordDisplay)
      ? (_openBlock(), _createBlock(_component_FeatherIcon, {
          key: 3,
          icon: "eye",
          class: "app-textfield-with-icon__inner-icon app-textfield-with-icon__inner-icon--right",
          onClick: _ctx.onClickDisplayPassword
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.showPasswordToggle && _ctx.isPasswordDisplay)
      ? (_openBlock(), _createBlock(_component_FeatherIcon, {
          key: 4,
          icon: "eye-off",
          class: "app-textfield-with-icon__inner-icon app-textfield-with-icon__inner-icon--right",
          onClick: _ctx.onClickDisplayPassword
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}